import React from "react";
import { Link } from "react-router-dom";
import { FiArrowUpRight } from "react-icons/fi";
import services from "../db/services";

const pad = (n) => String(n).padStart(2, "0");

const Services = ({ limit }) => {
  const list = limit ? services.slice(0, limit) : services;
  return (
    <div className="services">
      {list.map((s, i) => (
        <Link key={s.slug} to={`/services/${s.slug}`} className="service">
          <div className="num">{pad(i + 1)}</div>
          <div>
            <div className="code">{s.code}</div>
            <h3>{s.title}</h3>
            <p>{s.short}</p>
            <span className="more">Read service <FiArrowUpRight /></span>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default Services;
